import { Link } from 'react-router';
import PropTypes from 'prop-types';

import { CHECKOUT_STEP_MAP, NEW_ADDRESS_STEP } from 'constants/checkoutFlow';

import css from 'styles/components/checkout/caap/address/addresslist/shipToNewAddressSection.scss';

const ShipToNewAddressSection = ({ isBilling }, { testId }) => {
  if (isBilling) {
    return null;
  }
  return (
    <div className={css.shipToNewAddress}>
      <div className={css.linkContainer}>
        <Link to={`${CHECKOUT_STEP_MAP[NEW_ADDRESS_STEP]}?referrer=address`} data-test-id={testId('addNewShippingAddress')}>
          Ship to a new address
        </Link>
      </div>
      <p>Add a shipping address to your address book.</p>
    </div>
  );
};

ShipToNewAddressSection.contextTypes = {
  testId: PropTypes.func
};

export default ShipToNewAddressSection;
